module.exports = __webpack_public_path__ + "img/kangmingjian_img8.15ae2868.jpg";